<template>
  <div class="col-sm-12 col-md-12 col-lg-12 ">
    <h4>{{ type=='currently' ? 'Currently' : type }} issued
      <v-chip color="blue" class="text-white">{{ issued_books.length }}</v-chip>
    </h4>
    <table class="table ">
      <thead>
      <tr class="px-3">
        <th></th>
        <th class="wrap-column">#</th>
        <th class="wrap-column">Book name</th>
        <th class="wrap-column">Dates</th>
        <th v-if="type =='previously'" class="text-center wrap-column">Renewed after renew date</th>
        <th v-if="type =='currently'" class="text-center wrap-column">Remaining day</th>
      </tr>
      </thead>

      <tbody>
      <tr v-for="(issue, i) of issued_books" :key="i">
        <td>
          <v-checkbox outline dense :value="issue.id" v-model="selected_book"></v-checkbox>
        </td>
        <td class="wrap-column">
          <span class="font-weight-medium">
            {{ issue.book_accession_no }}
          </span>
        </td>
        <td class="wrap-column">
          <span class="font-weight-medium">
            {{ issue.book_title }}
          </span>
        </td>
        <td class="wrap-column">
          <div class="text-secondary">
              <span class="badge badge-secondary">Issued Date: {{issue.issue_date_text ? issue.issue_date_text : '-' }}</span>
          </div>
          <div class="text-secondary mt-3">
            <span class="badge badge-secondary">Due Return Date: {{issue.due_return_date_text ? issue.due_return_date_text : '-' }}</span>
          </div>
          <div class="text-secondary mt-3">
            <span class="badge badge-secondary">Renew Date: {{issue.renew_date_text ? issue.renew_date_text : '-' }}</span>
          </div>
          <div class="text-secondary mt-3">
            <span class="badge badge-secondary" v-if="issue.return_date_text">Return Date: {{issue.return_date_text ? issue.return_date_text : '-' }}</span>
          </div>

        </td>
        <td v-if="type =='previously'" class="text-center">
          <span>
               <i :class="!issue.renew_after_renew_date?'text-danger':'text-success'" class="fas fa-circle"></i>
            </span>
        </td>
        <td v-if="type =='currently'" class="font-weight-bold wrap-column text-center"
            :class="issue.renew_required?'text-danger':'text-success'">
          {{ `${issue.renew_required ? '-' + issue.remaining_renew_day : issue.remaining_renew_day}` }}
        </td>

      </tr>
      </tbody>
    </table>
    <div class="row" v-if="selected_book.length>0">
      <div class="col-12">
        <v-btn class="btn btn-primary text-white" depressed @click="openDialog('cancel_and_return')">Cancel &
          return
        </v-btn>
        <v-btn class="btn btn-primary text-white ml-2" depressed @click="openDialog('renew')">Renew</v-btn>
      </div>
    </div>
    <div>
      <!--      <b-modal id="modal-scrollable" size="md" ref="my-modal" hide-footer title="Return Book">-->
      <!--        <div class="row">-->
      <!--          <div class="col-12">-->
      <!--            <v-menu-->
      <!--                ref="menu1"-->
      <!--                v-model="menu1"-->
      <!--                :close-on-content-click="false"-->
      <!--                transition="scale-transition"-->
      <!--                offset-y-->
      <!--                max-width="290px"-->
      <!--                min-width="auto"-->
      <!--            >-->
      <!--              <template v-slot:activator="{ on, attrs }">-->
      <!--                <v-text-field-->
      <!--                    v-model="issue.return_date"-->
      <!--                    label="Date"-->
      <!--                    hint="MM/DD/YYYY format"-->
      <!--                    persistent-hint-->
      <!--                    prepend-icon="mdi-calendar"-->
      <!--                    v-bind="attrs"-->
      <!--                    outlined-->
      <!--                    dense-->
      <!--                    v-on="on"-->
      <!--                ></v-text-field>-->
      <!--              </template>-->
      <!--              <v-date-picker-->
      <!--                  v-model="issue.return_date"-->
      <!--                  no-title-->
      <!--                  @input="menu1 = false"-->
      <!--              ></v-date-picker>-->
      <!--            </v-menu>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="row">-->
      <!--          <div class="col-6">-->
      <!--            <b-button size="sm" class="mt-3 text-primary" variant="default" block @click="hideModal">Cancel</b-button>-->
      <!--          </div>-->
      <!--          <div class="col-6">-->
      <!--            <b-button size="sm" class="mt-2" :disabled="type !='currently'" variant="primary" block-->
      <!--                      @click="returnBook">Save-->
      <!--            </b-button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </b-modal>-->
      <return-book-modal :dialog="cancel_and_return_dialog" :issue_list="selected_book" :user_id="user.id"
                         @close_dialog="closeDialog" :library_setting="library_setting"></return-book-modal>
      <renew-modal :dialog="renew_dialog" :issue_list="selected_book" :user_id="user.id"
                         @close_dialog="closeDialog" :library_setting="library_setting"></renew-modal>
    </div>
  </div>
</template>

<script>
import IssueService from "@/core/services/library/issue/IssueService";
import ReturnBookModal from "@/view/component/IssueRenewAndReturnModal/ReturnBookModal";
import RenewModal from "@/view/component/IssueRenewAndReturnModal/RenewModal";
// import SettingService from "@/core/services/library/setting/SettingService";
//
// const settingService = new SettingService();
const issueService = new IssueService();
export default {
  name: "UserIssuedList",
  props: ['type', 'issued_books', 'action', 'user', 'library_setting'],
  components: {
    ReturnBookModal,
    RenewModal
  },
  data() {
    return {
      menu1: false,
      cancel_and_return_dialog: false,
      renew_dialog: false,
      issue: {},
      selected_book: []
    }
  }, watch: {
    issued_books(oldValue, newValue) {
      this.selected_book = [];
    }
  }, mounted(){
    // this.getLibrarySetting()
  },methods: {

    returnBook() {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            this.issue.status = "returned";
            issueService.update(this.issue.id, this.issue).then(response => {
              this.$snotify.success("Book returned successfully")
              this.hideModal()
              this.$emit('reload_issued_book')
            })
          }
        }
      })

    },
    renewBook(issue) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            issueService.update(issue.id, issue).then(response => {
              this.$snotify.success("Book renewed successfully")
              this.$emit('reload_issued_book')
            })
          }
        }
      })
    },
    openDialog(type) {
      if (type == "cancel_and_return")
        this.cancel_and_return_dialog = true;
      else
        this.renew_dialog = true;
    },
    closeDialog(type) {
      this.selected_book = [];
      if (type == "cancel_and_return") {
        this.cancel_and_return_dialog = false;
      } else {
        this.renew_dialog = false;
      }
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped>
  .wrap-column{
    max-width: 270px !important; 
    white-space: pre-wrap;
  }
</style>